// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:26:52.857Z
// Property: McKinney Village (ID: 6767906449166786)
// Collections: 31 amenities, 15 floorplans (live), 29 photos, 39 POIs, 2 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449166786",
  "property_external_id": "2206166",
  "property_zillow_url": "https://www.zillow.com/apartments/mckinney-tx/mckinney-village/CkChPK/",
  "property_apartments_url": "https://www.apartments.com/mckinney-village-mckinney-tx/6nnhsrs/",
  "property_google_business_url": "https://www.google.com/maps/place/201+McKinney+Village+Pkwy,+McKinney,+TX+75069/data=!4m2!3m1!1s0x864c11655798405f:0x22bff3ea3400ff02?sa=X&ved=2ahUKEwj7t5WI-bmSAxWpmGoFHWfHEZoQ8gF6BAglEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40833450414",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mckinney-village",
  "property_name": "McKinney Village",
  "property_website_url": "https://www.mckinneyvillageapts.com/",
  "property_domain": "https://www.mckinneyvillageapts.com/",
  "property_address": "201 McKinney Village Parkway",
  "property_full_address": "201 McKinney Village Pkwy, McKinney, TX 75069",
  "property_address_1": "201 McKinney Village Pkwy",
  "property_address_2": null,
  "property_address_city": "McKinney",
  "property_address_state": "TX",
  "property_address_zip_full": "75069",
  "property_address_zip": "75069",
  "property_address_country": "US",
  "property_address_county": "Collin County",
  "property_neighborhood_address": "Allen/McKinney",
  "property_address_latitude": "33.1613131",
  "property_address_longitude": "-96.6327479",
  "property_email": "mckinney@weidner.com",
  "property_phone": "(469) 634-0879",
  "property_call_tracking_phone": "469-727-8587",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Luxury living in McKinney’s Medical District.</strong> Explore polished studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with quartz countertops, stainless steel appliances, Nest thermostats, and in-home washer/dryer convenience—plus resort-inspired spaces built for downtime, work time, and weekends.</p>",
  "property_long_description": "<p><strong>Luxury living in McKinney’s Medical District.</strong> At McKinney Village, you’re positioned just off Hwy 75 and Hwy 5, with Frisco, Plano, and Historic Downtown McKinney within easy reach. Choose from polished studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a>, including a townhome-style layout, then settle into interiors with quartz countertops, stainless steel appliances, espresso cabinetry, wood-style flooring, Nest thermostats, electronic locks, garden tubs, and in-home washer/dryer convenience.</p><p><strong>Designed for downtime, work time, and weekends.</strong> Outside your door, the <a href=\"/amenities\">resort-style pool</a> brings a tanning ledge, in-water seating, cabanas, and a grilling station with an ice maker. You’ll also find a clubhouse with game tables, resident lounge with complimentary gourmet coffee, 24-hour fitness studio, business center with WiFi, serenity and community gardens, bike storage and repair, and an off-leash bark park. When you’re ready to explore, Downtown McKinney’s historic square, The Pantry Restaurant, Heard Natural Science Museum &amp; Wildlife Sanctuary, and McKinney’s parks and trails add local character close to home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
  "property_featured_image_media": {
    "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
    "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
    "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
    "width": 1600,
    "height": 1067
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "245",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": "9",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.65306122448979",
  "property_admin_fee": null,
  "property_application_fee": "85",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://mckinneyvillageapts.securecafe.com/onlineleasing/mckinney-village/floorplans.aspx",
  "property_resident_portal_url": "https://mckinneyvillageapts.securecafenet.com/residentservices/mckinney-village/userlogin",
  "property_apply_now_url": "https://mckinneyvillageapts.securecafe.com/onlineleasing/mckinney-village/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-dee2-75b9-90f7-b8660e430e50.webp",
  "property_primary_logo_media": {
    "alt_text": "McKinney Village Apartment Homes logo",
    "public_id": "019d01ab-dee2-75b9-90f7-b8660e430e50",
    "storage_key": "property/6767906449166786/019d01ab-dee2-75b9-90f7-b8660e430e50.webp",
    "width": 576,
    "height": 201
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e33-8b1e-765b-a194-304d0a73463d.webp",
  "property_secondary_logo_media": {
    "alt_text": "McKinney Village at the Medical District logo",
    "public_id": "01a03e33-8b1e-765b-a194-304d0a73463d",
    "storage_key": "property/6767906449166786/01a03e33-8b1e-765b-a194-304d0a73463d.webp",
    "width": 1572,
    "height": 1737
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-f4a7-77df-9d4a-2abb1d84aef4.webp",
  "property_icon_media": {
    "alt_text": "Mid-America Apartment Communities logo",
    "public_id": "019d01ae-f4a7-77df-9d4a-2abb1d84aef4",
    "storage_key": "property/6767906449166786/019d01ae-f4a7-77df-9d4a-2abb1d84aef4.webp",
    "width": 239,
    "height": 239
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-f4a7-77df-9d4a-2abb1d84aef4.webp",
  "property_fav_icon_media": {
    "alt_text": "Mid-America Apartment Communities logo",
    "public_id": "019d01ae-f4a7-77df-9d4a-2abb1d84aef4",
    "storage_key": "property/6767906449166786/019d01ae-f4a7-77df-9d4a-2abb1d84aef4.webp",
    "width": 239,
    "height": 239
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e3b-478d-72fa-a7c9-6e4d47f7a350.webp",
  "property_mono_white_logo_media": {
    "alt_text": "McKinney Village at Medical District logo",
    "public_id": "01a03e3b-478d-72fa-a7c9-6e4d47f7a350",
    "storage_key": "property/6767906449166786/01a03e3b-478d-72fa-a7c9-6e4d47f7a350.webp",
    "width": 576,
    "height": 201
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e3b-3c71-7577-9e55-684ea0a24c9e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "McKinney Village at Medical District logo",
    "public_id": "01a03e3b-3c71-7577-9e55-684ea0a24c9e",
    "storage_key": "property/6767906449166786/01a03e3b-3c71-7577-9e55-684ea0a24c9e.webp",
    "width": 576,
    "height": 201
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ce1443",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "575 - 1416",
  "property_sqft_min": "575",
  "property_sqft_max": "1416",
  "property_price_range": "1040 - 3645",
  "property_price_min": "1035",
  "property_price_max": "3150",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/McKinneyVillageLuxuryApartments/",
  "property_instagram_url": "https://www.instagram.com/mckinneyvillageapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJR7Y2rnoRTIYRblFOAoI3DiI",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to McKinney Village",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "<p><strong>Work, unwind, and recharge with ease.</strong> McKinney Village brings the details together: complimentary gourmet coffee in the resident lounge, a 24-hour fitness studio, and a resort-style pool with a tanning ledge, in-water seating, cabanas, and grilling station. Beyond the pool, find quieter perks like a serenity garden, community garden, bike storage and repair, plus an off-leash bark park. Inside, quartz countertops, stainless steel appliances, Nest thermostats, and spacious closets keep everyday living polished.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore studio, one-bedroom, two-bedroom, and townhome-style floor plans at McKinney Village, with open designs, two-bath options, and standout finishes like quartz countertops, stainless steel appliances, espresso cabinetry, kitchen islands, tall ceilings, Nest thermostats, and electronic locks. Select homes add extras such as wrap-around balconies or patios, pool or park views, garages, or carports.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture McKinney Village in full color.</strong> Preview bright kitchens with espresso cabinetry, quartz counters, pendant-lit islands, and stainless steel finishes, then glimpse open living areas, select balconies and patios, and community scenes worth a closer look.</p><p>From the resort-style pool and shaded cabanas to clubhouse lounge seating, game tables, and quiet garden corners, the gallery brings the details into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Your McKinney map starts here.</strong> McKinney Village puts US 75 errands, Historic Downtown McKinney dinners, and TUPPS Brewery nights within easy reach. Trade the usual route for Towne Lake Park trails and kayaking, or wander Adriatica Village for European-inspired shops and restaurants. Then come home to connected spaces like the pool, lounge, gardens, bike storage, and bark park.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews spotlight everyday ease.</strong> McKinney Village earns praise for “modern, lovely and sunny” apartments, a clean first impression, and a team described as friendly, efficient, and professional. Reviews also call out bright interiors, the inviting pool, great dog park, easy parking, and convenient access to Central Parkway and McKinney’s local charm. Read more to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your McKinney routine.</strong> From McKinney Village, you can move easily between the practical and the memorable: everyday stops along US 75, dinner plans around Historic Downtown McKinney’s brick-lined square, and local hangouts like TUPPS Brewery near The Flour Mill.</p><p>When you want fresh air, point the map toward Towne Lake Park for trails, disc golf, kayaking, and lakefront downtime, or explore Adriatica Village’s European-inspired streets, shops, and restaurants. Back at home, <a href=\"/amenities\">community spaces</a> like the pool, lounge, gardens, bike storage, and bark park keep the neighborhood feeling connected to your day—not separate from it. Use the map below to see what is close, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you are ready to experience the location in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that work as hard as they relax.</strong> At McKinney Village, your day can move from complimentary gourmet coffee in the resident lounge to a focused session in the 24-hour fitness studio, then out to the resort-style pool with a tanning ledge, in-water seating, cabanas, and a grilling station with an ice maker. Quiet moments have room here, too, with a serenity garden, community garden, bike storage and repair, and an off-leash bark park for pet-friendly convenience.</p><p>Inside, polished finishes keep everyday routines feeling sharp: quartz countertops, stainless steel appliances, espresso cabinetry, pendant-lit kitchen islands, tall ceilings, Nest thermostats, electronic locks, spacious closets, and washer/dryer options. See more in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at McKinney Village.</strong> Choose a polished studio, one-, or two-bedroom layout in McKinney’s Medical District, with upscale finishes like quartz countertops, stainless steel appliances, wood-style flooring, Nest thermostats, and in-home washer/dryer convenience. Apply online today and move one step closer to home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Reach out to the McKinney Village leasing team for help finding our Medical District location just off Hwy 75 and Hwy 5, or to ask about polished studio, one-, and two-bedroom floor plans with upscale finishes.</p>",
  "property_faqs_blurb": "<p><strong>Questions about McKinney Village?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and everyday living in McKinney’s Medical District. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> McKinney Village gives you a polished mix of studio, one-bedroom, two-bedroom, and townhome-style floor plans in McKinney, so you can compare open layouts, extra room to spread out, and two-bath designs side by side. Each floor plan card makes it easy to check current pricing, availability, and the details that matter before you tour.</p><p>Inside, look for elevated everyday finishes like quartz countertops, tile backsplashes, stainless steel appliances, espresso cabinetry, kitchen islands with pendant lighting, tall ceilings, Nest thermostats, electronic locks, generous closets, and washer/dryer convenience. Some homes may include a wrap-around balcony or patio, pool or park views, garage, or carport options. Browse the options below, explore more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> when one feels right.</p>",
  "property_gallery_blurb": "<p><strong>See the story in the details.</strong> Browse the McKinney Village photo gallery and picture bright kitchens framed by espresso cabinetry, quartz counters, pendant-lit islands, and stainless steel finishes. Living areas feel open under tall ceilings, while select balconies and patios add another angle on the community beyond your door.</p><p>Keep scrolling for the spaces that turn downtime into a scene: sunlit water at the <a href=\"/amenities\">resort-style pool</a>, lounge seating and game tables in the clubhouse, shaded cabanas along the sundeck, and quiet garden corners made for a slower moment. Like what you see? Compare <a href=\"/floor-plans\">studio, one-, and two-bedroom layouts</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience McKinney Village in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available <a href=\"/floor-plans\">studio, one-, and two-bedroom apartments</a> at McKinney Village, then use the interactive map to see how Hwy 75, Hwy 5, Historic Downtown McKinney, parks, trails, dining, and local destinations connect around this Medical District address.</p>",
  "property_pets_blurb": "<p><strong>More room for wagging tails and window-watchers.</strong> At McKinney Village, up to two pets can share your home, and daily pet routines feel easy—from quick fresh-air breaks to real playtime at the <a href=\"/amenities\">off-leash bark park</a>. After a romp, unwind in community green spaces or head back to an apartment with spacious closets for the gear, washer/dryer convenience for muddy towels, and select private patios or balconies for a sunny perch.</p><p>When you want a bigger outing, McKinney offers nearby dog-park and trail options, including Bonnie Wenk Dog Park with separate large- and small-dog areas and a splash pad. Review the pet policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your pet’s routine can fit here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the McKinney Village lifestyle.</strong> Love the polished interiors, resort-style pool, resident lounge, and easy access to McKinney, Frisco, and Plano? Refer a friend and invite them to find their next studio, one-, two-bedroom, or townhome-style home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your McKinney Village account—so you can get back to enjoying polished interiors, in-home washer/dryer convenience, and the resort-style spaces that make home feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>Real resident feedback, right at your fingertips.</strong> Reviews for McKinney Village highlight the details that make everyday living feel easy: apartments described as “modern, lovely and sunny,” a clean and polished first impression, and a team residents call “friendly, efficient, and very professional.”</p><p>As you read through the ratings, you’ll see praise for the sunny interiors, inviting pool, great dog park, and typically easy parking, along with convenient connections to Central Parkway and McKinney’s local charm. Browse the experiences below to get a clearer feel for what residents appreciate most about calling McKinney Village home.</p>",
  "property_created_at": "1761746976266",
  "property_scheduletour_blurb": "<p><strong>See McKinney Village in person.</strong> Tour polished studio, one-, and two-bedroom layouts, including a townhome-style option, and get a closer look at quartz countertops, stainless steel appliances, wood-style flooring, and resort-style spaces designed for work, downtime, and weekends. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>McKinney Village’s leasing team will be in touch soon. In the meantime, picture luxury living in McKinney’s Medical District, with polished studio, one-, and two-bedroom layouts, quartz countertops, stainless steel appliances, and relaxing community spaces designed for downtime, work time, and weekends.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layouts before you walk the property.</strong> Explore McKinney Village from wherever you are with virtual tours of five apartment options: The Foxx, The Harrelson, and The Henley one-bedroom layouts, plus The Nelson and The Reynolds two-bedroom layouts. As you click through, take in the flow from kitchen to living area, the everyday polish of quartz countertops, stainless steel appliances, espresso cabinetry, tall ceilings, spacious closets, and in-home laundry convenience.</p><p>Use each tour to compare proportions, storage, and room-to-room sightlines, then visit <a href=\"/floor-plans\">floor plans</a> for availability and pricing. When a layout feels like the right next step, <a href=\"/schedule-a-tour\">schedule a tour</a> to see McKinney Village in person.</p>",
  "property_copyright": "2026 All Rights Reserved. McKinney Village",
  "property_seo_title_home": "McKinney Village |  Apartments in McKinney, TX",
  "property_seo_description_home": "Discover luxury and comfort at McKinney Village with spacious floor plans, stunning amenities, and a serene lifestyle. Your new adventure awaits!",
  "property_seo_title_floorplans": "Floor Plans | McKinney, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at McKinney Village in McKinney, TX. Choose from studio, one, and two-bedroom layouts tailored for your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | McKinney, TX Apartments for Rent",
  "property_seo_description_amenities": "Unwind at McKinney Village! Enjoy a resort-style pool, modern fitness center, dog park, and luxury apartments—your ideal Texas retreat awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in McKinney, TX",
  "property_seo_description_gallery": "Unwind at McKinney Village, where luxury meets comfort. Enjoy stunning views, modern amenities, and vibrant community spaces. Picture your new lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | McKinney Village Apartments",
  "property_seo_description_virtualtours": "Step inside McKinney Village in TX! From cozy studios to spacious two-bedrooms, experience your future home with our immersive virtual tour. Join us now!",
  "property_seo_title_interactivemap": "Interactive Map | McKinney Village Apartments",
  "property_seo_description_interactivemap": "Find your perfect retreat at McKinney Village in McKinney, TX! From stylish studios to spacious two-bedrooms, our amenities enhance every lifestyle.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in McKinney, TX",
  "property_seo_description_neighborhood": "Explore McKinney Village's local favorites and attractions, where vibrant community meets convenience—just steps from your new home!",
  "property_seo_title_contact": "Contact Us | McKinney Village",
  "property_seo_description_contact": "Connect with McKinney Village in McKinney, TX! Whether you're interested in a studio or two-bedroom, our leasing team is here to answer your questions.",
  "property_seo_title_faqs": "FAQs | Apartments in McKinney, TX",
  "property_seo_description_faqs": "Find answers to your queries at McKinney Village in TX. From amenities to apartments, our FAQs page ensures you’re well-informed in no time!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in McKinney, TX",
  "property_seo_description_reviews": "Experience vibrant living at McKinney Village in TX! From stunning amenities to warm community vibes, see what our residents love about calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in McKinney, TX",
  "property_seo_description_applynow": "Experience modern living at McKinney Village! Enjoy luxurious amenities, from a resort-style pool to a serene garden. Apply now and make it your home today!",
  "property_seo_title_residentaccess": "Resident Access | McKinney Village",
  "property_seo_description_residentaccess": "Access the McKinney Village resident portal to pay rent, schedule maintenance, and manage your home easily—everything you need at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | McKinney Village",
  "property_seo_description_referafriend": "Refer a friend to McKinney Village and enhance your community with great neighbors! Share the joy of living in McKinney, TX. Your ideal home awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | McKinney Village",
  "property_seo_description_scheduletour": "Discover McKinney Village—your dream apartment community in McKinney, TX. Schedule a tour today to envision your vibrant new lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | McKinney Village",
  "property_seo_description_privacy": "Your privacy matters at McKinney Village. Dive into our privacy policy to see how we protect your information while you enjoy life in beautiful McKinney, TX.",
  "property_seo_title_accessibility": "Website Accessibility | McKinney Village",
  "property_seo_description_accessibility": "At McKinney Village in McKinney, TX, we prioritize digital inclusion. Experience accessible living that meets your needs—comfort and community await you!",
  "property_seo_title_sitemap": "Sitemap | McKinney Village",
  "property_seo_description_sitemap": "Uncover McKinney Village's vibrant amenities and charming lifestyle in McKinney, TX. Navigate our sitemap to find your perfect home and community today!",
  "property_seo_title_thankyou": "Thank You | McKinney Village",
  "property_seo_description_thankyou": "Thank you for reaching out to McKinney Village! Our team will connect with you soon to help you find your perfect home in vibrant McKinney, TX.",
  "property_seo_title_pets": "Pet Policy | Apartments in McKinney, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293668984",
  "amenities": [
    {
      "id": "ec_57cb75726a259464131e55b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "128691996",
      "title": "In Unit Washer/Dryer",
      "amount": "false",
      "description": "In Unit Washer/Dryer",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22139e70be069aeb6137bd5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "128679854",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0345609c245b8c049d790778",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "128679853",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e931171f1449931b2bfad74c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "128679852",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6507a63f7df8b8dc8516824d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549945",
      "title": "Clubhouse with Conversational Seating and Game Tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-a09e-75cf-bb25-f99df887a604.webp",
      "amenity_image_media": {
        "alt_text": "Lobby area with seating and a round table with chairs.",
        "public_id": "019d01ab-a09e-75cf-bb25-f99df887a604",
        "storage_key": "property/6767906449166786/019d01ab-a09e-75cf-bb25-f99df887a604.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c5fc9ffe38e56f7cb6ba430",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549946",
      "title": "Resident Lounge and Complimentary Gourmet Coffee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-9ebd-7339-b531-472787b18dc4.webp",
      "amenity_image_media": {
        "alt_text": "Spacious lounge area with a large counter, comfortable seating, and a TV.",
        "public_id": "019d01ab-9ebd-7339-b531-472787b18dc4",
        "storage_key": "property/6767906449166786/019d01ab-9ebd-7339-b531-472787b18dc4.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63510ef32725b379376a686e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549947",
      "title": "Resort-Style Pool with Tanning Ledge, In-Water Seating, and Large Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01aa-f717-76ee-b819-1d08a9787a50.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d01aa-f717-76ee-b819-1d08a9787a50",
        "storage_key": "property/6767906449166786/019d01aa-f717-76ee-b819-1d08a9787a50.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfdbb175c61d6b49ee5b7f3d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549948",
      "title": "Sundeck with Lounges, Covered Patio Seating, and Cabana Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-a160-749d-a666-da483642e8ee.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabana",
        "public_id": "019d01ab-a160-749d-a666-da483642e8ee",
        "storage_key": "property/6767906449166786/019d01ab-a160-749d-a666-da483642e8ee.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20ffa8f5f6f45af70a0a7911",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549949",
      "title": "Grilling Station with Two Grills and Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-acc9-7221-a716-195a6fdf9077.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio area with seating, coffee table, and built-in grills.",
        "public_id": "019d01ab-acc9-7221-a716-195a6fdf9077",
        "storage_key": "property/6767906449166786/019d01ab-acc9-7221-a716-195a6fdf9077.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ffb897f8a75422eb9256621",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549960",
      "title": "Quartz Countertops and Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-c365-741a-9d0f-55f12d283e9e.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and living area with island and bar stools",
        "public_id": "019d01ab-c365-741a-9d0f-55f12d283e9e",
        "storage_key": "property/6767906449166786/019d01ab-c365-741a-9d0f-55f12d283e9e.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4398bb3de1a46eac55982373",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549950",
      "title": "24-Hour Fitness Studio with Cardio Equipment, Free Weights, Resistance & Circuit Training, and Yoga Balls",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-3827-7409-b92f-b0976bae67d7.webp",
      "amenity_image_media": {
        "alt_text": "Modern fitness center with cardio machines and weightlifting equipment.",
        "public_id": "019d01ab-3827-7409-b92f-b0976bae67d7",
        "storage_key": "property/6767906449166786/019d01ab-3827-7409-b92f-b0976bae67d7.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cfe51cf8322638e9519a82d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549981",
      "title": "Stainless Steel Appliance Package including a Side-by-Side Refrigerator, Self-Cleaning Oven, Built-in Microwave, and Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4773bbacf575f9a32b978cfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549951",
      "title": "Business Center with Complimentary WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-2aba-7445-874e-0f58671e1845.webp",
      "amenity_image_media": {
        "alt_text": "Business center with two computers and chairs.",
        "public_id": "019d01ab-2aba-7445-874e-0f58671e1845",
        "storage_key": "property/6767906449166786/019d01ab-2aba-7445-874e-0f58671e1845.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "A white desk with a chair and a mirror on the wall.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5cbb28f3fca1b85e17a224b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549982",
      "title": "Espresso Cabinetry and Brushed Nickel Hardware",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c3cb6614157d197db996b4a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549952",
      "title": "Serenity Garden with Bench Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-b57d-732c-82e1-93cdf59efb5e.webp",
      "amenity_image_media": {
        "alt_text": "Exterior courtyard with benches, landscaping, and building exteriors.",
        "public_id": "019d01ab-b57d-732c-82e1-93cdf59efb5e",
        "storage_key": "property/6767906449166786/019d01ab-b57d-732c-82e1-93cdf59efb5e.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "A building with a staircase and a bench in front of it.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970288c149a232219b941cc8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549984",
      "title": "Track Lighting and Spacious Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e698b497fd6438f98ad737bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549953",
      "title": "Community Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-be00-716c-af3e-b5afb975959a.webp",
      "amenity_image_media": {
        "alt_text": "Raised garden beds with greenery and white decorative fencing in a grassy area with trees and a blue sky.",
        "public_id": "019d01ab-be00-716c-af3e-b5afb975959a",
        "storage_key": "property/6767906449166786/019d01ab-be00-716c-af3e-b5afb975959a.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d80dcb1fc0f6748b34fc3a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549985",
      "title": "Gourmet Kitchen Island with Pendant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019fbc07-f915-7340-8046-92cea0b4d125.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment kitchen with dark cabinets, granite countertops, and an island with bar stools.",
        "public_id": "019fbc07-f915-7340-8046-92cea0b4d125",
        "storage_key": "property/6767906449166786/019fbc07-f915-7340-8046-92cea0b4d125.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "A kitchen with a white island and dark brown cabinets.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae0122f2d325e284a4065e3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549954",
      "title": "Off-Leash Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-3cad-770e-a2f4-d28262c62a87.webp",
      "amenity_image_media": {
        "alt_text": "Fenced dog park with green grass and trees, with apartment buildings in the background.",
        "public_id": "019d01ab-3cad-770e-a2f4-d28262c62a87",
        "storage_key": "property/6767906449166786/019d01ab-3cad-770e-a2f4-d28262c62a87.webp",
        "width": 1600,
        "height": 1066
      },
      "amenity_image_alt_text": "A large grassy field with a fence and trees in the distance.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5ab0cc562b3adb570887ff0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125564534",
      "title": "Soaring 9' and 10' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-cd3f-715a-b56d-fa0653343c1a.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with a white sofa, blue armchair, and abstract art.",
        "public_id": "019d01ab-cd3f-715a-b56d-fa0653343c1a",
        "storage_key": "property/6767906449166786/019d01ab-cd3f-715a-b56d-fa0653343c1a.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6438fb3e24a11ced90f4173d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549955",
      "title": "Bike Repair Station and Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd3ba9c00e87cb2246dbdf32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549987",
      "title": "Nest Programmable Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7d1b0da76667c140836c989",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549988",
      "title": "Electronic Locks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc5f91c585e1f7ddd2d9e5f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549956",
      "title": "Park Benches and Bicycle Parking Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f75821faf57261ecb7303c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549989",
      "title": "Bedrooms with Ceiling Fans and Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-ce38-7439-b98c-766617bdba3f.webp",
      "amenity_image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, gray headboard, and mirrored nightstands.",
        "public_id": "019d01ab-ce38-7439-b98c-766617bdba3f",
        "storage_key": "property/6767906449166786/019d01ab-ce38-7439-b98c-766617bdba3f.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9f2add1258aa48cecb88316",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549957",
      "title": "Elevators in Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-be5d-7409-849c-4dbebc3634dc.webp",
      "amenity_image_media": {
        "alt_text": "Interior of a modern elevator with stainless steel doors and a digital panel.",
        "public_id": "019d01ab-be5d-7409-849c-4dbebc3634dc",
        "storage_key": "property/6767906449166786/019d01ab-be5d-7409-849c-4dbebc3634dc.webp",
        "width": 600,
        "height": 750
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31908c0508bb74252841616e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549958",
      "title": "*Garages and Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acf7ccb72a32dcabf582898e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549990",
      "title": "Bathrooms with Garden Tub, Curved Shower Rod, and Linen Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with granite countertops, dark cabinets, and a large mirror. Bedroom visible through the doorway.",
        "public_id": "019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf",
        "storage_key": "property/6767906449166786/019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de9fa4362e375402990662bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549986",
      "title": "Soaring 9' and 10' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaa694de8257e1a785326824",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549992",
      "title": "*Large Wrap-Around Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_928db64b3d6f1fe1cef447cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "125549993",
      "title": "*Pool and Park Views Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_2ed81e8ea9a5db53adfbcd41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-0c7f-7026-9b8d-619c3031e9dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island seating",
        "public_id": "019d01ab-0c7f-7026-9b8d-619c3031e9dd",
        "storage_key": "property/6767906449166786/019d01ab-0c7f-7026-9b8d-619c3031e9dd.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with an island, perfect for entertaining. Enjoy ample natural light and stylish finishes.",
      "link": "false",
      "alt_text": "A modern kitchen with dark brown cabinets and a white island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(1).jpg"
    },
    {
      "id": "ec_f581de19990dabb7b974262e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertops, dark cabinets, and a large mirror. Bedroom visible through the doorway.",
        "public_id": "019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf",
        "storage_key": "property/6767906449166786/019d01ab-1a37-766c-8c9a-5f1bdf0f7fdf.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a large mirror. The adjacent bedroom is visible, offering a glimpse into the apartment's living spaces.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and a vase of flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(2).jpg"
    },
    {
      "id": "ec_d6bd1e949dfe13ff760bf028",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-0261-7340-a1cd-9cde1673d619.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, armchair, coffee table, and TV.",
        "public_id": "019d01ab-0261-7340-a1cd-9cde1673d619",
        "storage_key": "property/6767906449166786/019d01ab-0261-7340-a1cd-9cde1673d619.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living area featuring a white sectional sofa, a pale blue armchair, a dark wood coffee table, and a wall-mounted television, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "A living room with a white couch, a blue chair, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(3).jpg"
    },
    {
      "id": "ec_21b6a67e97c7decef1ba2c35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-0253-7770-8519-b779643f08a2.webp",
      "image_media": {
        "alt_text": "Modern living room with a white couch, blue armchair, and large abstract art.",
        "public_id": "019d01ab-0253-7770-8519-b779643f08a2",
        "storage_key": "property/6767906449166786/019d01ab-0253-7770-8519-b779643f08a2.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring comfortable seating, large windows, and tasteful decor, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A living room with a white couch, a coffee table, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(4).jpg"
    },
    {
      "id": "ec_8ac20fb4663bb0b766adcc0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-1895-70b1-baf7-e5b7b9096b7b.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, nightstands, and a ceiling fan.",
        "public_id": "019d01ab-1895-70b1-baf7-e5b7b9096b7b",
        "storage_key": "property/6767906449166786/019d01ab-1895-70b1-baf7-e5b7b9096b7b.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, modern nightstands, and a refreshing ceiling fan.",
      "link": "false",
      "alt_text": "A bedroom with a large bed, a ceiling fan, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(5).jpg"
    },
    {
      "id": "ec_805bca8d6eb347e122687cc8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-0f8f-763c-8b7c-20d0930e7d2b.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-sized bed, plush bedding, and a ceiling fan.",
        "public_id": "019d01ab-0f8f-763c-8b7c-20d0930e7d2b",
        "storage_key": "property/6767906449166786/019d01ab-0f8f-763c-8b7c-20d0930e7d2b.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed bedroom, featuring elegant decor and a serene ambiance.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(6).jpg"
    },
    {
      "id": "ec_1273d0bb1d7a264cd2c0b87b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-1a4c-739e-923a-bb2072b77c46.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white robe, storage bins, and handbags.",
        "public_id": "019d01ab-1a4c-739e-923a-bb2072b77c46",
        "storage_key": "property/6767906449166786/019d01ab-1a4c-739e-923a-bb2072b77c46.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe. Includes a plush robe and decorative storage bins.",
      "link": "false",
      "alt_text": "A white bathroom with a towel hanging on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(7).jpg"
    },
    {
      "id": "ec_eae29eade7e93875c28388cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-0e0b-74d0-8f5d-9e7819d11c36.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, large mirror, toilet, and walk-in closet.",
        "public_id": "019d01ab-0e0b-74d0-8f5d-9e7819d11c36",
        "storage_key": "property/6767906449166786/019d01ab-0e0b-74d0-8f5d-9e7819d11c36.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern double vanity with granite countertops, a large framed mirror, and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(8).jpg"
    },
    {
      "id": "ec_4cee2ccf07b376f61e77d5e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-2582-776d-a8f1-582c93f6945a.webp",
      "image_media": {
        "alt_text": "A stylish lounge area with tic-tac-toe and chess tables, comfortable seating, and a bar.",
        "public_id": "019d01ab-2582-776d-a8f1-582c93f6945a",
        "storage_key": "property/6767906449166786/019d01ab-2582-776d-a8f1-582c93f6945a.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring interactive games and elegant seating.",
      "link": "false",
      "alt_text": "A modern dining room with a large table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(9).jpg"
    },
    {
      "id": "ec_6672e259c355bab431105f46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-240f-762b-8dc6-e1006b47db4f.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with a large counter, seating, and a TV.",
        "public_id": "019d01ab-240f-762b-8dc6-e1006b47db4f",
        "storage_key": "property/6767906449166786/019d01ab-240f-762b-8dc6-e1006b47db4f.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Discover comfort and style in our community lounge, featuring a modern counter, ample seating, and entertainment options.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(10).jpg"
    },
    {
      "id": "ec_1603e0e0851f15cdf15e26ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-31f7-7142-bba8-929c615a676d.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with comfortable seating, a coffee bar, and a TV.",
        "public_id": "019d01ab-31f7-7142-bba8-929c615a676d",
        "storage_key": "property/6767906449166786/019d01ab-31f7-7142-bba8-929c615a676d.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed resident lounge, featuring a stylish seating area, complimentary coffee bar, and entertainment center.",
      "link": "false",
      "alt_text": "A spacious living room with a variety of seating options and a large mirror on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(11).jpg"
    },
    {
      "id": "ec_125b3f362d11e272269d8b1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-2ab7-7090-a313-ae8ad0cefeab.webp",
      "image_media": {
        "alt_text": "A modern bar area with a waterfall countertop, bar stools, and a marble-patterned backsplash.",
        "public_id": "019d01ab-2ab7-7090-a313-ae8ad0cefeab",
        "storage_key": "property/6767906449166786/019d01ab-2ab7-7090-a313-ae8ad0cefeab.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Enjoy drinks and socializing at our stylish bar, featuring a sleek countertop, comfortable seating, and elegant marble accents.",
      "link": "false",
      "alt_text": "A bar area with a counter and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(12).jpg"
    },
    {
      "id": "ec_d557e59770a28057b2e64445",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-2aba-7445-874e-0f58671e1845.webp",
      "image_media": {
        "alt_text": "Business center with two computers and chairs.",
        "public_id": "019d01ab-2aba-7445-874e-0f58671e1845",
        "storage_key": "property/6767906449166786/019d01ab-2aba-7445-874e-0f58671e1845.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Work or relax in our resident business center, equipped with computers and comfortable seating.",
      "link": "false",
      "alt_text": "A white chair sits in front of a desk with a computer monitor and a clock.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(13).jpg"
    },
    {
      "id": "ec_601c0c38a6e4f96104a68821",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-3827-7409-b92f-b0976bae67d7.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines and weightlifting equipment.",
        "public_id": "019d01ab-3827-7409-b92f-b0976bae67d7",
        "storage_key": "property/6767906449166786/019d01ab-3827-7409-b92f-b0976bae67d7.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including treadmills, stationary bikes, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(14).jpg"
    },
    {
      "id": "ec_7760b811569b6916b81abf0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-1bf0-70aa-aa2f-f28a27167abe.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with plush seating and a bar.",
        "public_id": "019d01ab-1bf0-70aa-aa2f-f28a27167abe",
        "storage_key": "property/6767906449166786/019d01ab-1bf0-70aa-aa2f-f28a27167abe.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Relax and unwind in our elegant community lounge, featuring comfortable seating and a stylish bar area perfect for socializing.",
      "link": "false",
      "alt_text": "A living room with a brown leather couch and a grey armchair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(15).jpg"
    },
    {
      "id": "ec_b4464f08d299573085dce221",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-30fa-70da-b4d3-bd09855a1d05.webp",
      "image_media": {
        "alt_text": "Stylish lobby seating area with a plush sofa, elegant chairs, and a modern coffee table.",
        "public_id": "019d01ab-30fa-70da-b4d3-bd09855a1d05",
        "storage_key": "property/6767906449166786/019d01ab-30fa-70da-b4d3-bd09855a1d05.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lobby, featuring comfortable seating perfect for meeting friends or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "A well-lit, spacious living room with a grey sofa, a coffee table, and a large window with curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(16).jpg"
    },
    {
      "id": "ec_6fa0bfd99a77a7202f4b37c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019ddcf3-cb29-7489-9933-8e675c40b8cf.webp",
      "image_media": {
        "alt_text": "Covered patio area with seating overlooking a swimming pool and apartment buildings.",
        "public_id": "019ddcf3-cb29-7489-9933-8e675c40b8cf",
        "storage_key": "property/6767906449166786/019ddcf3-cb29-7489-9933-8e675c40b8cf.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Relax on your private patio or by the resort-style swimming pool. Enjoy the sunshine and beautiful views of our apartment community.",
      "link": "false",
      "alt_text": "A patio with a table and chairs overlooking a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(17).jpg"
    },
    {
      "id": "ec_3cecda02e90c748150dae467",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-00fa-724d-8d92-9b0cafe2808a.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with submerged lounge chairs and a covered patio area.",
        "public_id": "019d01ab-00fa-724d-8d92-9b0cafe2808a",
        "storage_key": "property/6767906449166786/019d01ab-00fa-724d-8d92-9b0cafe2808a.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Relax and unwind in our stunning outdoor swimming pool, featuring submerged lounge chairs and a spacious covered patio perfect for enjoying the sunshine.",
      "link": "false",
      "alt_text": "A pool with white chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(18).jpg"
    },
    {
      "id": "ec_651cb0e361f972ccb957e345",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01aa-f717-76ee-b819-1d08a9787a50.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d01aa-f717-76ee-b819-1d08a9787a50",
        "storage_key": "property/6767906449166786/019d01aa-f717-76ee-b819-1d08a9787a50.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the pool or relax on the sun loungers. This beautiful outdoor swimming pool is surrounded by lush landscaping and apartment buildings.",
      "link": "false",
      "alt_text": "Swimming pool area with lounge chairs and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(19).jpg"
    },
    {
      "id": "ec_8dcd738c3421955e4f138713",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019ddcf3-cb30-71e6-97fe-c93b2666a012.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a clubhouse in the background",
        "public_id": "019ddcf3-cb30-71e6-97fe-c93b2666a012",
        "storage_key": "property/6767906449166786/019ddcf3-cb30-71e6-97fe-c93b2666a012.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a beautifully designed clubhouse.",
      "link": "false",
      "alt_text": "A large swimming pool in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(20).jpg"
    },
    {
      "id": "ec_ea697e0f7a38be992d018bb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-385f-7416-9f4e-d80d8949610b.webp",
      "image_media": {
        "alt_text": "Dog park with a sign and fenced-in area.",
        "public_id": "019d01ab-385f-7416-9f4e-d80d8949610b",
        "storage_key": "property/6767906449166786/019d01ab-385f-7416-9f4e-d80d8949610b.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with a dedicated area for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "A sign for a dog park is displayed in front of a metal fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(21).jpg"
    },
    {
      "id": "ec_4e4c674a904e9f3699541e34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-3cad-770e-a2f4-d28262c62a87.webp",
      "image_media": {
        "alt_text": "Fenced dog park with green grass and trees, with apartment buildings in the background.",
        "public_id": "019d01ab-3cad-770e-a2f4-d28262c62a87",
        "storage_key": "property/6767906449166786/019d01ab-3cad-770e-a2f4-d28262c62a87.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, perfect for your furry friends to play and socialize in a safe and clean environment.",
      "link": "false",
      "alt_text": "A large grassy field with a fence and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(22).jpg"
    },
    {
      "id": "ec_a4653b55d5ca6f0889656293",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-be00-716c-af3e-b5afb975959a.webp",
      "image_media": {
        "alt_text": "Raised garden beds with greenery and white decorative fencing in a grassy area with trees and a blue sky.",
        "public_id": "019d01ab-be00-716c-af3e-b5afb975959a",
        "storage_key": "property/6767906449166786/019d01ab-be00-716c-af3e-b5afb975959a.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy a breath of fresh air in our community garden, featuring beautifully maintained raised beds perfect for growing your own herbs and vegetables.",
      "link": "false",
      "alt_text": "Raised garden beds with greenery and white decorative fencing in a grassy area with trees and a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(23).jpg"
    },
    {
      "id": "ec_33b3a567219700c130623bd5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-4b02-76fc-bd0f-7311df684b7c.webp",
      "image_media": {
        "alt_text": "Playground with slide and climbing structure, fenced in with green space and apartment buildings in the background.",
        "public_id": "019d01ab-4b02-76fc-bd0f-7311df684b7c",
        "storage_key": "property/6767906449166786/019d01ab-4b02-76fc-bd0f-7311df684b7c.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for residents of all ages. Features a slide, climbing structure, and safe play surface.",
      "link": "false",
      "alt_text": "A playground with a green slide and a brown sandbox.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(24).jpg"
    },
    {
      "id": "ec_cef1a72710d145c2875713aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-3fa6-73c0-bc8f-c582e63ba562.webp",
      "image_media": {
        "alt_text": "Fenced dog park with a covered seating area and green grass.",
        "public_id": "019d01ab-3fa6-73c0-bc8f-c582e63ba562",
        "storage_key": "property/6767906449166786/019d01ab-3fa6-73c0-bc8f-c582e63ba562.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a safe and fun space for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "Fenced dog park with a covered seating area and green grass.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(25).jpg"
    },
    {
      "id": "ec_ed0ca894ebec51dee4992286",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-a160-749d-a666-da483642e8ee.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabana",
        "public_id": "019d01ab-a160-749d-a666-da483642e8ee",
        "storage_key": "property/6767906449166786/019d01ab-a160-749d-a666-da483642e8ee.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, complete with comfortable lounge chairs and a shaded cabana area.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabana",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(26).jpg"
    },
    {
      "id": "ec_1e2c7c77db2fd4a60a938e8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01aa-f5e5-750d-a0ce-3b506f5b6084.webp",
      "image_media": {
        "alt_text": "McKinney Village building entrance with signage and parking spaces.",
        "public_id": "019d01aa-f5e5-750d-a0ce-3b506f5b6084",
        "storage_key": "property/6767906449166786/019d01aa-f5e5-750d-a0ce-3b506f5b6084.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Community",
      "description": "Welcome to McKinney Village, featuring a well-maintained building entrance and ample parking.",
      "link": "false",
      "alt_text": "McKinney Village building entrance with signage and parking spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(27).jpg"
    },
    {
      "id": "ec_61017694cd4fad94ff375f1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-4cf1-71ca-9f2f-d9f14d6094b4.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with white trim and balconies.",
        "public_id": "019d01ab-4cf1-71ca-9f2f-d9f14d6094b4",
        "storage_key": "property/6767906449166786/019d01ab-4cf1-71ca-9f2f-d9f14d6094b4.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautifully designed apartment building, featuring spacious balconies and a charming brick exterior.",
      "link": "false",
      "alt_text": "A row of red brick apartment buildings with white trim and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(28).jpg"
    },
    {
      "id": "ec_33719adee181aa3dbd457535",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ab-4e18-734e-8e81-0a9cd3a6226c.webp",
      "image_media": {
        "alt_text": "McKinney Village at the Medical District monument sign and building exterior.",
        "public_id": "019d01ab-4e18-734e-8e81-0a9cd3a6226c",
        "storage_key": "property/6767906449166786/019d01ab-4e18-734e-8e81-0a9cd3a6226c.webp",
        "width": 1000,
        "height": 471
      },
      "title": "Community",
      "description": "Welcome to McKinney Village at the Medical District, offering a premier living experience in a vibrant community.",
      "link": "false",
      "alt_text": "McKinney Village at the Medical District sign in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_McKinney_Village_Favorites%20(29).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7a54eb17-5572-4d10-94d9-fb27e438716c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Hutchins BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1301 N Tennessee St, McKinney, TX 75069, USA",
      "poi_short_description": "BBQ specializing in Texas-style eats such as brisket, ribs, sausage and pulled pork.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and Texas Twinkies. They highlight the generous portions, free dessert, and family-friendly atmosphere. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-2f22-716b-9e82-67984ffae362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-2f22-716b-9e82-67984ffae362",
        "storage_key": "property/6767906449166786/019d01ad-2f22-716b-9e82-67984ffae362.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hutchinsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16734697326257327246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hutchins-bbq",
      "poi_latitude": "33.2112483",
      "poi_longitude": "-96.6154684",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-548-2629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6514-7608-b488-1e1797c9027b",
        "storage_key": "property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYydEW1ESTIYRjkw_042WPeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_a44a12be-d002-40e8-8925-fa455f0d1894",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "190 E Stacy Rd #700, Allen, TX 75002, USA",
      "poi_short_description": "Casual, 'secret-menu' chain for hamburgers, fries and shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and animal-style fries. They highlight the fresh ingredients, fast service, and affordable prices. They also like the clean restrooms and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-2ea0-76af-ae4c-b5a21ed9168f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-2ea0-76af-ae4c-b5a21ed9168f",
        "storage_key": "property/6767906449166786/019d01ad-2ea0-76af-ae4c-b5a21ed9168f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/255",
      "poi_directions_map_url": "https://maps.google.com/?cid=488632914307302927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.1291504",
      "poi_longitude": "-96.6532967",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6514-7608-b488-1e1797c9027b",
        "storage_key": "property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNT9WgCgRTIYRD8bZ8gv5xwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_27226320-4df0-464e-b326-99c0cdd81de8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Topgolf Allen",
      "poi_type": "Restaurants",
      "poi_address": "1500 Andrews Pkwy, Allen, TX 75002, USA",
      "poi_short_description": "Golf facility with a driving range and a restaurant featuring American eats, beers and wine.",
      "poi_long_description": "People say this restaurant offers fun games and good drinks. They also highlight the attentive staff and the manager's exceptional service.\n\nOther reviews mention the food can be subpar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-2e56-739f-84e5-7391ef368779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-2e56-739f-84e5-7391ef368779",
        "storage_key": "property/6767906449166786/019d01ad-2e56-739f-84e5-7391ef368779.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://topgolf.com/us/allen/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13672768288814690153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-allen",
      "poi_latitude": "33.1231048",
      "poi_longitude": "-96.6586367",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-675-9730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6514-7608-b488-1e1797c9027b",
        "storage_key": "property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcK6ztUQTIYRaW8GN1Fuv70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_57438d8f-b673-42a6-b57a-5aa59f172fc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "820 S Central Expy, Allen, TX 75013, USA",
      "poi_short_description": "Casual chain offering a large menu of chicken dishes such as orange chicken alongside cheesecake and other desserts.",
      "poi_long_description": "People say this restaurant offers a wide variety of dishes, including pasta, burgers, Asian-inspired plates, and, of course, cheesecake. They also highlight the generous portions, perfect for sharing, and the rich, creamy, and delicious cheesecake.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-2ef8-73c5-844b-838192acc610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-2ef8-73c5-844b-838192acc610",
        "storage_key": "property/6767906449166786/019d01ad-2ef8-73c5-844b-838192acc610.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/tx/allen-142.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=2141911463149233651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "33.0891353",
      "poi_longitude": "-96.6828169",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-908-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6514-7608-b488-1e1797c9027b",
        "storage_key": "property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCw6XnUMXTIYR8-VYnSCZuR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_03522fa8-3a50-4a5b-b398-dd06048b928b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "The Yard McKinney TX",
      "poi_type": "Restaurants",
      "poi_address": "107 S Church St, McKinney, TX 75069, USA",
      "poi_short_description": "Relaxed, family-friendly and dog-friendly hangout featuring burgers, tacos and chicken sandwiches.",
      "poi_long_description": "People say this restaurant serves delicious burgers, fish tacos, and chicken tenders, and offers a variety of other options like nachos, wings, and salads. They highlight the fun, casual, and welcoming atmosphere, and the dog-friendly outdoor seating area. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-33c6-7052-adc2-0391c4590e0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-33c6-7052-adc2-0391c4590e0b",
        "storage_key": "property/6767906449166786/019d01ad-33c6-7052-adc2-0391c4590e0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.yardtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17131837259207050645&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-yard-mckinney-tx",
      "poi_latitude": "33.1963957",
      "poi_longitude": "-96.61715900000002",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-631-0035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6514-7608-b488-1e1797c9027b",
        "storage_key": "property/6767906449166786/019d01ad-6514-7608-b488-1e1797c9027b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV1T-K2ETTIYRlYXWCDiDwO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5bb9da30-6a56-46fd-b73e-99717c783a37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Allen Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "820 W Stacy Rd, Allen, TX 75013, USA",
      "poi_short_description": "Outdoor outlet mall with dining options, featuring clothing, accessory, shoe & home stores.",
      "poi_long_description": "People say this outlet mall offers a wide selection of brand-name stores, including clothing, shoes, and accessories. They also highlight the great deals and outlet prices, and the convenient parking.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3400-734f-bc55-f6a1feba9652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3400-734f-bc55-f6a1feba9652",
        "storage_key": "property/6767906449166786/019d01ad-3400-734f-bc55-f6a1feba9652.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/allen",
      "poi_directions_map_url": "https://maps.google.com/?cid=6120537669728539068&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "allen-premium-outlets",
      "poi_latitude": "33.1327179",
      "poi_longitude": "-96.6607514",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-678-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-651b-7532-913e-c5118fca0ea6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-651b-7532-913e-c5118fca0ea6",
        "storage_key": "property/6767906449166786/019d01ad-651b-7532-913e-c5118fca0ea6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbfTPbiwRTIYRvBGRJpWE8FQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c9614b9b-6ba4-42ab-9a23-6b236f45db0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "575 E Exchange Pkwy, Allen, TX 75002, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including fresh produce, quality meats, and unique local and international specialties. They highlight the good prices, clean and well-organized store, and the convenient curbside pickup and self-checkout options. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-33c5-75dd-afa7-ebd9fcc25642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-33c5-75dd-afa7-ebd9fcc25642",
        "storage_key": "property/6767906449166786/019d01ad-33c5-75dd-afa7-ebd9fcc25642.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/allen/h-e-b-allen-796?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=602535134317451488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "33.117174",
      "poi_longitude": "-96.6534386",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-656-9401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6510-75b8-a638-97afbfa0358b",
        "storage_key": "property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLaPwssQRTIYR4BivJYOiXAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_29935766-5fc0-430b-8fd9-d64f1114a31c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "105 Stacy Rd, Fairview, TX 75069, USA",
      "poi_short_description": "Organic, health-conscious grocer (part of a chain) with prepared foods and hot bar options.",
      "poi_long_description": "People say this grocery store offers fresh produce, organic options, and a wide variety of specialty items. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3884-7044-9a33-052947b0c29b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3884-7044-9a33-052947b0c29b",
        "storage_key": "property/6767906449166786/019d01ad-3884-7044-9a33-052947b0c29b.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/fairview?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17168231520267799887&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.1310936",
      "poi_longitude": "-96.6565457",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-549-4090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6510-75b8-a638-97afbfa0358b",
        "storage_key": "property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZiWmigRTIYRTw06Q5vPQe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_516e62d0-7cf4-4548-87f6-ab82c957c88b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2851 Craig Dr STE 100, McKinney, TX 75070, USA",
      "poi_short_description": "Market featuring organic snacks, breads, meat, produce, cheese and other items, plus friendly service.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, organic, and vegan foods, as well as a large selection of wines and fresh produce. They highlight the affordable prices, especially for seasonal items, and the clean, well-organized, and positive vibe. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-388d-77ff-9d9b-2ade5082355a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-388d-77ff-9d9b-2ade5082355a",
        "storage_key": "property/6767906449166786/019d01ad-388d-77ff-9d9b-2ade5082355a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/tx/mckinney/408/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17266751574040084074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.1737298",
      "poi_longitude": "-96.6428785",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-491-1893",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6510-75b8-a638-97afbfa0358b",
        "storage_key": "property/6767906449166786/019d01ad-6510-75b8-a638-97afbfa0358b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTgGP-ATTIYRan6TyxLTn-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3db1783b-4ce8-4bd4-bf68-ce3535bc83dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Collin College Technical Campus",
      "poi_type": "Education",
      "poi_address": "2550 Bending Branch Way, Allen, TX 75013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-38c2-74cb-9e0c-9e61dafe1a1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-38c2-74cb-9e0c-9e61dafe1a1a",
        "storage_key": "property/6767906449166786/019d01ad-38c2-74cb-9e0c-9e61dafe1a1a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.collin.edu/campuses/technical/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13930837176379365461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "collin-college-technical-campus",
      "poi_latitude": "33.128012",
      "poi_longitude": "-96.7137428",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-553-1290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6516-76e2-9b41-fe909720e68a",
        "storage_key": "property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHfPf-pwXTIYRVdjlaZpGVME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_780f256c-bd88-44e3-88f3-2c0f43c7dc39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "John and Judy Gay Public Library",
      "poi_type": "Education",
      "poi_address": "6861 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Place for books with computers and study rooms, plus friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3902-7289-addb-d232e61bce6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3902-7289-addb-d232e61bce6d",
        "storage_key": "property/6767906449166786/019d01ad-3902-7289-addb-d232e61bce6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mckinneytexas.org/Index.aspx?NID=116",
      "poi_directions_map_url": "https://maps.google.com/?cid=6889068524554534185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-and-judy-gay-public-library",
      "poi_latitude": "33.1736639",
      "poi_longitude": "-96.7062909",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-547-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6516-76e2-9b41-fe909720e68a",
        "storage_key": "property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1xL1TisUTIYRKb1lv1Ljml8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5e9269a4-e7c5-4236-bef7-aa601876d282",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "McKinney Campus",
      "poi_type": "Education",
      "poi_address": "2200 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3d43-7557-acea-baad97fb8c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3d43-7557-acea-baad97fb8c7d",
        "storage_key": "property/6767906449166786/019d01ad-3d43-7557-acea-baad97fb8c7d.webp",
        "width": 1280,
        "height": 1112
      },
      "poi_business_url": "http://www.collin.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798731976724431200&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinney-campus",
      "poi_latitude": "33.2181719",
      "poi_longitude": "-96.6418315",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-548-6790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6516-76e2-9b41-fe909720e68a",
        "storage_key": "property/6767906449166786/019d01ad-6516-76e2-9b41-fe909720e68a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGR5rDHUTTIYRYMG_K7byWV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a55a3cee-1fcb-43fa-8601-2738e1411dd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3150 S Hardin Blvd, McKinney, TX 75070, USA",
      "poi_short_description": "Sprawling amusement park featuring trampolines, a ninja course, a sky rider, and an indoor playground.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, obstacle courses, a ropes course, and a zip line. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3cc5-76e6-88ee-67bb09d572fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3cc5-76e6-88ee-67bb09d572fa",
        "storage_key": "property/6767906449166786/019d01ad-3cc5-76e6-88ee-67bb09d572fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-mckinney/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16341390045620196206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "33.1665362",
      "poi_longitude": "-96.6664791",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-532-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fsI120XTIYRbtNLhapHyOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6d98c530-73c7-4a53-bbd9-a41498896a7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "McKinney ISD District-wide Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4201 S Hardin Blvd, McKinney, TX 75070, USA",
      "poi_short_description": "Modern stadium for high school football games, marching band events and soccer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3d61-72eb-84bd-9f93847e3c1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3d61-72eb-84bd-9f93847e3c1d",
        "storage_key": "property/6767906449166786/019d01ad-3d61-72eb-84bd-9f93847e3c1d.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10528834656872311856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinney-isd-district-wide-stadium",
      "poi_latitude": "33.1579148",
      "poi_longitude": "-96.6603637",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68d1-733f-95b4-449fe535b36f",
        "storage_key": "property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj-c4D00RTIYRMCyyFVbvHZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7c7c5883-521e-4c55-9b54-8d11cdd088c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Eagle Stadium",
      "poi_type": "Entertainment",
      "poi_address": "155 Rivercrest Blvd, Allen, TX 75002, USA",
      "poi_short_description": "Impressive stadium for the local high school that holds sporting events.",
      "poi_long_description": "Fans say this high school stadium is impressive, with a college-level atmosphere and tasty, reasonably priced concessions. They also highlight the efficient service and ample restrooms, making it a convenient spot to enjoy a game.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-3eda-755b-92a0-8ff10e632887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-3eda-755b-92a0-8ff10e632887",
        "storage_key": "property/6767906449166786/019d01ad-3eda-755b-92a0-8ff10e632887.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allenisd.org/page/eagle-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=14235980376519427635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagle-stadium",
      "poi_latitude": "33.1141001",
      "poi_longitude": "-96.656993",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-727-0437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68d1-733f-95b4-449fe535b36f",
        "storage_key": "property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDd4hPc4QTIYRM0bfG7pckMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_a9ac7267-3a2b-474b-af6b-2c0b57aca8f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Ron Poe Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Duvall St, McKinney, TX 75069, USA",
      "poi_short_description": "Facility with a track and field, plus bleachers and turf, that's good for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4226-76ba-9c47-ac67cbeddefa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4226-76ba-9c47-ac67cbeddefa",
        "storage_key": "property/6767906449166786/019d01ad-4226-76ba-9c47-ac67cbeddefa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://departments.mckinneyisd.net/athletics/ron-poe-stadium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4792681953913191153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ron-poe-stadium",
      "poi_latitude": "33.2072108",
      "poi_longitude": "-96.633645",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-302-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68d1-733f-95b4-449fe535b36f",
        "storage_key": "property/6767906449166786/019d01ad-68d1-733f-95b4-449fe535b36f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh_i9F6UTTIYR8bprKNgGg0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_570a19df-4b37-4a01-85af-8f74313712c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Play Street Museum - McKinney",
      "poi_type": "Entertainment",
      "poi_address": "3851 S Stonebridge Dr STE 400, McKinney, TX 75070, USA",
      "poi_short_description": "Clean play space with a farm theme, for kids 0-8 to enjoy imaginative play.",
      "poi_long_description": "Visitors say this children's museum is a great place for birthday parties, with a spacious and clean environment, friendly and helpful staff, and a variety of interactive and educational play areas. They also highlight the museum's reasonable prices, well-organized layout, and the staff's assistance in setting up and running parties smoothly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4236-733e-a985-9fc5f1f21aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4236-733e-a985-9fc5f1f21aad",
        "storage_key": "property/6767906449166786/019d01ad-4236-733e-a985-9fc5f1f21aad.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://mckinney.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7324313924764299048&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "play-street-museum---mckinney",
      "poi_latitude": "33.1681393",
      "poi_longitude": "-96.7312159",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 469-596-6046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68d6-750d-82d4-2c290069e763.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68d6-750d-82d4-2c290069e763",
        "storage_key": "property/6767906449166786/019d01ad-68d6-750d-82d4-2c290069e763.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9VRQyOEVTIYRKO8FbbUwpWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_66c2e73a-8711-4418-8027-ac694a698d8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "971 State Hwy 121, Allen, TX 75013, USA",
      "poi_short_description": "Workout facility offering a fitness floor, group classes, indoor and outdoor pools, steam rooms and trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4295-72a9-a9ac-b1d91d980a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4295-72a9-a9ac-b1d91d980a8c",
        "storage_key": "property/6767906449166786/019d01ad-4295-72a9-a9ac-b1d91d980a8c.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/allen.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13516609626603926008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.1411523",
      "poi_longitude": "-96.6793887",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-383-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3F6A8QWTIYR-DFaYdeklLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a96e098c-bcb0-4665-83f1-a43fbab32b81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "PSA McKinney",
      "poi_type": "Health and Wellness",
      "poi_address": "7205 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Gym with a volleyball court and basketball court, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-43ef-74dd-8991-f37e904b888d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-43ef-74dd-8991-f37e904b888d",
        "storage_key": "property/6767906449166786/019d01ad-43ef-74dd-8991-f37e904b888d.webp",
        "width": 1280,
        "height": 1175
      },
      "poi_business_url": "http://psaplano.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7106161131863611713&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "psa-mckinney",
      "poi_latitude": "33.1730509",
      "poi_longitude": "-96.7120724",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-208-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJxCsjdMVTIYRQRlrPeYnnmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1aede77f-d4fc-456e-ae1f-24eb736ddbd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Crunch Fitness - Allen",
      "poi_type": "Health and Wellness",
      "poi_address": "510 North Watters Road, Allen, TX 75013, USA",
      "poi_short_description": "Gym offering a \"no judgments\" philosophy, group fitness classes, and personal training.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of equipment, including massage chairs and hydro beds, as well as cryotherapy. They also highlight the friendly and helpful staff, and the clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-48ff-72cf-9235-899fdcc72e2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-48ff-72cf-9235-899fdcc72e2a",
        "storage_key": "property/6767906449166786/019d01ad-48ff-72cf-9235-899fdcc72e2a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.crunch.com/locations/allen",
      "poi_directions_map_url": "https://maps.google.com/?cid=16974863605481307731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---allen",
      "poi_latitude": "33.1039514",
      "poi_longitude": "-96.6831094",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-824-3022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-0OImEXTIYRU35rM4PUkus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_49d7f9ab-1f6b-4fd3-a577-57d5231011cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "117 S Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "",
      "poi_long_description": "Gym goers say this fitness center offers a wide variety of quality equipment, a clean facility, and helpful, friendly staff. They also highlight the affordable rates and Black Card perks, such as tanning and hydro massages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-48ff-72cf-9235-870997f15855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-48ff-72cf-9235-870997f15855",
        "storage_key": "property/6767906449166786/019d01ad-48ff-72cf-9235-870997f15855.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2560030239414489793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.1970221",
      "poi_longitude": "-96.6370058",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-936-0906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3woyVDMTTIYRwRKPavANhyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_bab0440a-15c9-49dc-874a-accd96ea19ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2875 S Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "Health-club chain featuring an array of classes, weight machines, free weights and gym equipment for members.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4a11-73a9-aaab-62d5444c72a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4a11-73a9-aaab-62d5444c72a7",
        "storage_key": "property/6767906449166786/019d01ad-4a11-73a9-aaab-62d5444c72a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=301&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10657477064975616531&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.1737289",
      "poi_longitude": "-96.6378173",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-952-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_y2od8TTIYRE4q-w-z25pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0c02e6c5-7041-4b57-a7eb-e6d7740a56bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 N Hardin Blvd, McKinney, TX 75071, USA",
      "poi_short_description": "Gym chain offering a pool, basketball court, cardio and weight machines, and classes.",
      "poi_long_description": "People say this gym offers a variety of cardio machines, a pool, and a sauna, and the staff is friendly and helpful.\n\nOther reviews mention the facilities can be poorly maintained and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4c78-773e-a56d-59f7eef056a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4c78-773e-a56d-59f7eef056a5",
        "storage_key": "property/6767906449166786/019d01ad-4c78-773e-a56d-59f7eef056a5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/mckinney-tx/mckinney-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=3246479707611805654&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "33.2142765",
      "poi_longitude": "-96.6637671",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-678-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpaZ91agTTIYR1je37hfQDS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b49ceff1-490f-4a70-b2f6-6dd94cee1d78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "605 W McDermott Dr, Allen, TX 75013, USA",
      "poi_short_description": "Large gym featuring free weights, benches, machines and squat racks, plus a sauna.",
      "poi_long_description": "Visitors say this gym has a spacious layout with a variety of equipment, including a basketball court, cardio machines, and a sauna. They also highlight the friendly and helpful staff, as well as the clean and well-maintained environment.\n\nSome reviews mention the membership cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4d2d-745e-bf2b-3fdb84202556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4d2d-745e-bf2b-3fdb84202556",
        "storage_key": "property/6767906449166786/019d01ad-4d2d-745e-bf2b-3fdb84202556.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/allen/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4127177927126771593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "33.1000086",
      "poi_longitude": "-96.6766763",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-390-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7zir0cXTIYRiWc5P3WuRjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a7b81033-a4fe-4be9-85e4-90a803c27a05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "190 E Stacy Rd #2680, Allen, TX 75002, USA",
      "poi_short_description": "Retailer of make-up, skincare and perfume products, plus a hair salon and eyebrow bar.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4d60-730e-b9af-5dde59ba0591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4d60-730e-b9af-5dde59ba0591",
        "storage_key": "property/6767906449166786/019d01ad-4d60-730e-b9af-5dde59ba0591.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/allen-tx-1583",
      "poi_directions_map_url": "https://maps.google.com/?cid=11963862345648864807&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.1271077",
      "poi_longitude": "-96.6591705",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-886-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08lBB2ERTIYRJ34ShmotCKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_cc5bee1e-1e6f-4ed1-a8f5-80bc9363464f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "CLUB4 Fitness McKinney",
      "poi_type": "Health and Wellness",
      "poi_address": "3190 S Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "Membership-based gym offering exercise equipment, tanning, and a sauna, plus hydro massage.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities like a sauna and hydromassage, and a kids club, and is affordable.\n\nOther reviews mention the equipment can be broken and the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-4fda-7209-b814-86c1a3436843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-4fda-7209-b814-86c1a3436843",
        "storage_key": "property/6767906449166786/019d01ad-4fda-7209-b814-86c1a3436843.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/mckinney/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4098057476268738373&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-mckinney",
      "poi_latitude": "33.1700218",
      "poi_longitude": "-96.643268",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-447-4949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr5KyveURTIYRRcch7o853zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ffd977d-533c-4218-9ea8-12a182b39fc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Medical City McKinney",
      "poi_type": "Health and Wellness",
      "poi_address": "4500 Medical Center Dr, McKinney, TX 75069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5177-73fe-afac-b78b4537751f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5177-73fe-afac-b78b4537751f",
        "storage_key": "property/6767906449166786/019d01ad-5177-73fe-afac-b78b4537751f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-mckinney-hospital?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6127100865065554328&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medical-city-mckinney",
      "poi_latitude": "33.1602913",
      "poi_longitude": "-96.6371158",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-547-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6908-750a-a544-01a6e116e302.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6908-750a-a544-01a6e116e302",
        "storage_key": "property/6767906449166786/019d01ad-6908-750a-a544-01a6e116e302.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8aWWSW8RTIYRmJE4JcbVB1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3313460a-f908-46f1-b4fd-5973bc9608a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - McKinney",
      "poi_type": "Health and Wellness",
      "poi_address": "5252 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-525b-74d4-856d-c77b93d4888d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-525b-74d4-856d-c77b93d4888d",
        "storage_key": "property/6767906449166786/019d01ad-525b-74d4-856d-c77b93d4888d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/mckinney?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13053395923665302371&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-scott--white-medical-center---mckinney",
      "poi_latitude": "33.221056",
      "poi_longitude": "-96.682481",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-764-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6908-750a-a544-01a6e116e302.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6908-750a-a544-01a6e116e302",
        "storage_key": "property/6767906449166786/019d01ad-6908-750a-a544-01a6e116e302.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5qYi4sUTIYRYzOaxm76JrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fceceda3-06c3-4ee3-9ac9-4e28e7d3738c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Celebration Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 N Angel Pkwy, Allen, TX 75002, USA",
      "poi_short_description": "Big park with green spaces for soccer and baseball, plus playgrounds and a splash pad.",
      "poi_long_description": "People say this city park offers a large playground, splash pad, walking trails, and sports fields. They highlight the family-friendly atmosphere, clean facilities, and ample parking. They also like the open space and shaded picnic areas, ideal for birthdays and family gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-534d-7442-b8a9-0ab36d2c97d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-534d-7442-b8a9-0ab36d2c97d5",
        "storage_key": "property/6767906449166786/019d01ad-534d-7442-b8a9-0ab36d2c97d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofallen.org/facilities.aspx?RID=15&Page=detail",
      "poi_directions_map_url": "https://maps.google.com/?cid=17362805481601570230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "celebration-park",
      "poi_latitude": "33.1074291",
      "poi_longitude": "-96.6240878",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bf4-73f1-b874-2707aef46c5c",
        "storage_key": "property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2x-hWPQQTIYRthUR65cT9fA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ecd795f0-5e13-4676-bca0-435cd8cc48c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Heard Natural Science Museum & Wildlife Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Nature Pl, McKinney, TX 75069, USA",
      "poi_short_description": "Nature sanctuary featuring hiking trails, a ropes course, and a science museum, plus seasonal exhibits.",
      "poi_long_description": "People say this nature preserve offers educational exhibits, hiking trails, and a dinosaur exhibit. They highlight the family-friendly atmosphere, fun experience, and great value. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-56f0-775a-acf8-c7b539abb7b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-56f0-775a-acf8-c7b539abb7b8",
        "storage_key": "property/6767906449166786/019d01ad-56f0-775a-acf8-c7b539abb7b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.heardmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9562119403549279734&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heard-natural-science-museum--wildlife-sanctuary",
      "poi_latitude": "33.1579212",
      "poi_longitude": "-96.6151955",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-562-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bf4-73f1-b874-2707aef46c5c",
        "storage_key": "property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8JZ85sRTIYR9sVsbO94s4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e2846e85-6e1c-4740-87ee-27324b73905b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Bonnie Wenk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2996 Virginia Pkwy, McKinney, TX 75071, USA",
      "poi_short_description": "Sprawling park with a dog park, trails, lake and kids' playgrounds.",
      "poi_long_description": "People say this city park offers multiple playgrounds, a fishing pond, nature trails, and a dog park. They highlight the beautiful, sparkling lake, the zip line, and the outdoor gym, and like the well-maintained grounds and clean restrooms. They also mention the park provides ample parking and shade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-57e7-77bb-ab4c-745d22ca494b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-57e7-77bb-ab4c-745d22ca494b",
        "storage_key": "property/6767906449166786/019d01ad-57e7-77bb-ab4c-745d22ca494b.webp",
        "width": 1024,
        "height": 512
      },
      "poi_business_url": "https://www.mckinneytexas.org/1148/Bonnie-Wenk-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17385907888518791576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bonnie-wenk-park",
      "poi_latitude": "33.1982361",
      "poi_longitude": "-96.6620671",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-547-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bf4-73f1-b874-2707aef46c5c",
        "storage_key": "property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6CZK4oTTIYRmAHTMBwnR_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_320e7938-da7f-4897-9253-0ea03b0c4254",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Towne Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1405 Wilson Creek Pkwy, McKinney, TX 75069, USA",
      "poi_short_description": "Family-friendly recreation area with playgrounds, ballfields and fishing.",
      "poi_long_description": "People say this city park offers a walking trail, playground, fishing, and kayak rentals. They highlight the beautiful lake, picnic areas, and opportunities for outdoor activities like volleyball and frisbee golf. They also like the clean restrooms, ample parking, and the presence of ducks and turtles. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-56e4-7513-982c-36371dbe10b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-56e4-7513-982c-36371dbe10b3",
        "storage_key": "property/6767906449166786/019d01ad-56e4-7513-982c-36371dbe10b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mckinneytexas.org/912/Towne-Lake-Recreation-Area",
      "poi_directions_map_url": "https://maps.google.com/?cid=16061805727982545681&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "towne-lake-park",
      "poi_latitude": "33.1849258",
      "poi_longitude": "-96.6323446",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-547-2690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bf4-73f1-b874-2707aef46c5c",
        "storage_key": "property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-z_Fc8MTTIYREeu74zX_5t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_44997b69-547a-4ba7-94d9-82bbb10edf02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Spirit Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1151 Ridgeview Dr, Allen, TX 75013, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this park has great play areas for children of all ages and neat walkways for strolling along a green belt or forest. They also highlight the amazing playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5a41-73af-9703-6846b298c380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5a41-73af-9703-6846b298c380",
        "storage_key": "property/6767906449166786/019d01ad-5a41-73af-9703-6846b298c380.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofallen.org/facilities/facility/details/spiritpark-107",
      "poi_directions_map_url": "https://maps.google.com/?cid=5259096104784916816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spirit-park",
      "poi_latitude": "33.1298754",
      "poi_longitude": "-96.6936862",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-509-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bf4-73f1-b874-2707aef46c5c",
        "storage_key": "property/6767906449166786/019d01ad-6bf4-73f1-b874-2707aef46c5c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31KPKeAXTIYRUHFYHQsQ_Eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c368590c-4f3c-409d-b12f-f13aa14cb839",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "McKinney National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1508 Industrial Blvd, McKinney, TX 75069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5c56-721a-afab-b52efee26d7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5c56-721a-afab-b52efee26d7e",
        "storage_key": "property/6767906449166786/019d01ad-5c56-721a-afab-b52efee26d7e.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "http://www.flytki.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14560522122723772330&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinney-national-airport",
      "poi_latitude": "33.1767774",
      "poi_longitude": "-96.59264",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-984-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6bfb-717e-b25c-34f3dc68620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6bfb-717e-b25c-34f3dc68620c",
        "storage_key": "property/6767906449166786/019d01ad-6bfb-717e-b25c-34f3dc68620c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WCI6BwSTIYRqscqxbldEco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_752c7343-e83c-4ae4-a35a-79335c67519e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "WatchGuard Video",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 E Exchange Pkwy, Allen, TX 75002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5cb4-734e-ad2d-574051c9587a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5cb4-734e-ad2d-574051c9587a",
        "storage_key": "property/6767906449166786/019d01ad-5cb4-734e-ad2d-574051c9587a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.watchguardvideo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7389678990693329873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "watchguard-video",
      "poi_latitude": "33.1171507",
      "poi_longitude": "-96.6613105",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-605-6734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSXjTNIQTIYR0WtxzONpjWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7f860928-9e0f-441b-8244-5d36d8fc50fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "SRS Distribution Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7440 State Hwy 121, McKinney, TX 75070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5c69-75ec-b831-89112602130f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5c69-75ec-b831-89112602130f",
        "storage_key": "property/6767906449166786/019d01ad-5c69-75ec-b831-89112602130f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.srsdistribution.com/en/markets/our-brands/ZZNA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3395211632795249017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "srs-distribution-inc",
      "poi_latitude": "33.1349079",
      "poi_longitude": "-96.7079243",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-491-4149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-V7QKYTTIYReekIzv02Hi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fc88779d-f711-4227-8b0e-305e52885005",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Allen City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "305 Century Pkwy, Allen, TX 75013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-5f49-747b-8e3c-42ca13772ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-5f49-747b-8e3c-42ca13772ae3",
        "storage_key": "property/6767906449166786/019d01ad-5f49-747b-8e3c-42ca13772ae3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cityofallen.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14422956487283948157&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "allen-city-hall",
      "poi_latitude": "33.1004762",
      "poi_longitude": "-96.6734958",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-509-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-6c13-764e-bc90-25bc95371075.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-6c13-764e-bc90-25bc95371075",
        "storage_key": "property/6767906449166786/019d01ad-6c13-764e-bc90-25bc95371075.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QaoNUUXTIYRfbp5U4KiKMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_00c3282a-b6c4-4698-93eb-8fef57d719c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "Cookies-n-Milk Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "181 Industrial Blvd, McKinney, TX 75069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-613e-7572-948a-34e74e1ce291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ad-613e-7572-948a-34e74e1ce291",
        "storage_key": "property/6767906449166786/019d01ad-613e-7572-948a-34e74e1ce291.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cookiesnmilkinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722166427554024220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cookies-n-milk-inc",
      "poi_latitude": "33.1797183",
      "poi_longitude": "-96.6118236",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-491-6370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVR9Pi8STIYRHAsmp6ntbr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_92d3e3c2-355d-48b0-a99c-2063cd5c2349",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "poi_name": "PCI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "405 Interchange St, McKinney, TX 75071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pciconstruction.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5646156076043526160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pci",
      "poi_latitude": "33.2208631",
      "poi_longitude": "-96.61158890000002",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-562-2762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ad-68ce-779a-b21c-06dc3e937487",
        "storage_key": "property/6767906449166786/019d01ad-68ce-779a-b21c-06dc3e937487.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwVzMRUTTIYREOD8WgktW04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_49ec31cd72e771803334805e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2274e026ca13207689a3099f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_015dc28059da68a3a078054e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0fc900db462e6eed0d92922f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "THU",
      "open_time": "10:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_d6672810389f30a825479a9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c66864438b9be6c5ea66a2fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_c8eb44c2675ecc60edcc5bb4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "rating": "5",
      "name": "false",
      "text": "The apartments are modern, lovely and sunny. The pool is nice and there is a great doggie park. Definitely for pet lovers, but not a requirement! Parking is usually easy. Also easy connect to Central Parkway and the quaint town of McKinney isn't far away. All ages live here, from young singles to small families and some spunky seniors. Paige",
      "date": "false",
      "title": "Lovely Apartments"
    },
    {
      "id": "ec_8d81d9919b3c1e086d0e5824",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "rating": "5",
      "name": "false",
      "text": "I came in looking for a one bedroom and the 1st thing I noticed was how clean and neat it was , the staff was friendly, efficient, and very professional.  I was delighted to be shown by Amy she asked questions, made me feel comfortable and answer every question I had she is AMAZING!!! Looking forward to living here soon!\n\n",
      "date": "false",
      "title": "Amazing Tour!!!"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bc62a673-b6b7-4566-95ad-ad630113bbae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e39-8685-752f-9af6-232b41f81804.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03e39-8685-752f-9af6-232b41f81804",
        "storage_key": "property/6767906449166786/01a03e39-8685-752f-9af6-232b41f81804.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Foxx | 1x1 | 720 sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2BreEemGxim"
    },
    {
      "id": "custom_4007ce1d-8fdf-4b76-b305-d7f60ab6a015",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e39-b072-759f-bca1-75d0f50be954.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03e39-b072-759f-bca1-75d0f50be954",
        "storage_key": "property/6767906449166786/01a03e39-b072-759f-bca1-75d0f50be954.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Harrelson | 1x1 | 750 sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dzuWvFoRFsf"
    },
    {
      "id": "custom_1f8eaafd-4843-4b24-919c-f7dd123b1630",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e39-d45c-712d-b8f0-d6f3cbd576d2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03e39-d45c-712d-b8f0-d6f3cbd576d2",
        "storage_key": "property/6767906449166786/01a03e39-d45c-712d-b8f0-d6f3cbd576d2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Henley | 1x1 | 810 sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=htjy2SQBAtk"
    },
    {
      "id": "custom_c88c32fe-1cfc-4b60-b955-807155e47b1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e39-f940-7309-9cd2-fcdfb5184db4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03e39-f940-7309-9cd2-fcdfb5184db4",
        "storage_key": "property/6767906449166786/01a03e39-f940-7309-9cd2-fcdfb5184db4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Nelson | 2x2 | 1235 sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QjKodPfF7rh"
    },
    {
      "id": "custom_44b2ab7f-1bb4-464d-afb1-2427cfadf85f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/01a03e3a-14fa-73eb-9574-4bfa4e6687bd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03e3a-14fa-73eb-9574-4bfa4e6687bd",
        "storage_key": "property/6767906449166786/01a03e3a-14fa-73eb-9574-4bfa4e6687bd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Reynolds | 2x2 | 1272 sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aTz7ogkLx8t"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_29fd18dcff2a200f7a2b5231",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "db06795cfd648fdf",
      "name": "NSF Tenant Fee",
      "description": "Returned Payment Charge",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_799ea8dc028fc880f124bbef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "58a680c308d87653",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_12b1897beca0a6dd0d4fa8aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "630030f022704e40",
      "name": "Electric Chargeback",
      "description": "Electric Utility Charge - Charged to resident if account is not set up with utility provider",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_da565ce10bfdb5b552a8bee3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "debdd12541727b45",
      "name": "Electric Fee",
      "description": "Electric Utility Fee - Charged to resident if account is not set up with utility provider",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Utility",
      "charge_code": "elecfee",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_52d19acdb4bb09ccdc7362cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "c85bff9184755d0e",
      "name": "Water Chargeback",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_10fa717935083edc190b3881",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "f1854befa1beb917",
      "name": "Sewer Chargeback",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_613229f0de8ff2b29e90b62d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "ebda5f7438ca5e4a",
      "name": "Garbage Chargeback",
      "description": "Trash Utility Charge",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "garb",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb457b915de2837ff296065a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "b08b5620b4dc54f7",
      "name": "Utility Billing Admin Fee",
      "description": "Admin Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies based on utility charges, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_95821badc76696a3e4c76387",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "d62375efa6548725",
      "name": "Lease Termination Fee",
      "description": "Lease Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_aa76c1e88588eab483b05165",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "6753897128ba607f",
      "name": "Transfer Fee",
      "description": "Transfer Fee - On-Site or Sister Property Transfer",
      "amount": 1000,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_baf3067752eaee70d801505b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "726cf3023ddb7eb4",
      "name": "Month to Month Fee",
      "description": "Month to Month Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies based on lease term.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Lease",
      "charge_code": "mtom",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f300f3b5e44d2c1c45b037c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "73903bbf418897e2",
      "name": "Short Term Lease Premium",
      "description": "Short Term Lease Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies based on lease term.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Lease",
      "charge_code": "prem",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_cf933f1eaff77f53ef707aa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "yardi",
      "external_id": "2682680",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 200,
      "fee": 300,
      "monthly_rent": 30,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "019a3060-5b43-762e-ae8a-8a638a743b10",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "weidner-mckinney-village",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-mckinney-tx",
      "search_query": "luxury apartments with in-unit laundry McKinney TX",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience the best in McKinney, TX with our luxury apartments offering in-unit laundry. Enjoy high-end features and easy living in McKinney's Medical District.",
      "page_copy": "Discover a lifestyle of convenience and elegance at McKinney Village, where luxury apartments with in-unit laundry redefine your living experience. Nestled in the vibrant heart of McKinney, TX, our community presents modern studio, one-, and two-bedroom floor plans, each equipped with a top-of-the-line in-home washer and dryer, letting you enjoy the ultimate convenience at your fingertips. \n\nBeyond the comforts of your apartment, engage in a variety of upscale amenities such as our resident lounge with complimentary gourmet coffee or the 24-hour fitness center featuring state-of-the-art cardio machines and free weights. Living in McKinney Village means embracing a seamless blend of style and function, with every detail carefully curated to enhance your life in this thriving Texas locale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments In-Unit Laundry McKinney",
      "seo_description": "Explore luxury apartments in McKinney, TX with in-unit laundry. Enjoy upscale living with high-end amenities and easy convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-resort-style-pool-mckinney",
      "search_query": "apartments with resort-style pool in McKinney",
      "category": "Amenity",
      "h1_title": "Apartments with Resort-Style Pool",
      "h2_subtitle": "Dive into luxury with our apartments featuring a resort-style pool in McKinney. Experience relaxation like never before at McKinney Village.",
      "page_copy": "At McKinney Village, immerse yourself in leisure and luxury with our exquisite resort-style pool, a highlight feature of our premier apartments in McKinney. This tranquil haven offers an ideal escape from the everyday, making every day feel like a vacation right at home. Whether lounging poolside or enjoying a refreshing swim, our pool is the perfect spot for relaxation and rejuvenation.\n\nIn addition to the captivating pool, our community boasts an array of lavish amenities, such as a resident lounge complete with complimentary gourmet coffee and a 24-hour fitness studio featuring modern cardio equipment and free weights. Discover the perfect balance of comfort and style in McKinney, TX, where life's best moments await you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Resort-Style Pool in McKinney",
      "seo_description": "Explore McKinney Village's apartments with a resort-style pool. Experience the ultimate relaxation and high-end living in McKinney, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-near-allen-mckinney",
      "search_query": "dog-friendly apartments near Allen McKinney",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near Allen",
      "h2_subtitle": "Find your perfect home at McKinney Village. Offering dog-friendly apartments near Allen with an off-leash park and pet-friendly amenities.",
      "page_copy": "Welcome to McKinney Village, the ideal choice for dog-friendly apartments near Allen. Nestled in the heart of McKinney, our community is perfectly suited for pet-lovers. Your canine companion will enjoy our off-leash bark park, designed to let them roam freely and socialize with other furry friends. \n\nOur lushly landscaped grounds provide a serene setting, blending the comforts of home with the joy of pet-friendly living. In addition to welcoming your pets, McKinney Village offers refined studio, one-, and two-bedroom floor plans complete with high-end finishes like quartz countertops and in-home washer/dryer units. Discover a community where every member of the family feels at home, just a short drive from Allen's best shopping and dining.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Allen, McKinney",
      "seo_description": "Discover dog-friendly apartments near Allen at McKinney Village, offering a bark park and luxury amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-dedicated-parking-collin-county",
      "search_query": "apartments with dedicated parking in Collin County",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking",
      "h2_subtitle": "Enjoy the convenience of dedicated parking at McKinney Village in Collin County. Our modern apartments ensure easy access and peace of mind.",
      "page_copy": "Discover the convenience of apartments with dedicated parking at McKinney Village, located in the heart of Collin County. Our community offers a modern living experience, combining the luxury of contemporary design with practical amenities like dedicated parking spaces. Say goodbye to the daily stress of searching for parking and enjoy the ease that comes with having a reserved spot just for you.\n\nMcKinney Village features meticulously designed studio, one-, and two-bedroom apartments with premium finishes and fixtures. Beyond our parking facilities, residents can indulge in amenities such as a 24-hour fitness studio, a cozy resident lounge with gourmet coffee, and an expansive off-leash bark park, ensuring comfort and convenience in every aspect of life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dedicated Parking in Collin County",
      "seo_description": "Find modern apartments with dedicated parking in Collin County at McKinney Village. Enjoy stress-free living in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-mckinney-tx",
      "search_query": "apartments with stainless steel appliances McKinney TX",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover sleek style in McKinney, TX with our apartments featuring stainless steel appliances. Experience modern living at McKinney Village.",
      "page_copy": "At McKinney Village, our apartments are thoughtfully designed to include stainless steel appliances, adding a touch of modern elegance to your home in McKinney, TX. Our studio, one-, and two-bedroom floor plans boast kitchens equipped with high-end stainless steel features, ensuring every meal prep moment is a delight. These chic appliances complement the quartz countertops and spacious layouts, providing both form and function.\n\nLiving at McKinney Village means more than just stylish interiors. Our community offers amenities that enhance your lifestyle – from a 24-hour fitness studio complete with all the essentials, to a comfortable resident lounge serving complimentary gourmet coffee, and even a bike repair station for the cycling enthusiast. Experience the perfect blend of contemporary design and upscale living in McKinney's Medical District.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Stainless Steel Appliances in McKinney, TX",
      "seo_description": "Explore McKinney Village's apartments with stainless steel appliances. Enjoy modern living with chic design in McKinney, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "studio-apartments-mckinney-tx",
      "search_query": "studio apartments in McKinney TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in McKinney, TX",
      "h2_subtitle": "Explore luxury studio apartments at McKinney Village in TX. Designed for comfort and convenience, ideal for modern living.",
      "page_copy": "Discover the perfect blend of comfort and style with studio apartments in McKinney, TX at McKinney Village. Our studio spaces are meticulously crafted to maximize living area while offering the finest contemporary finishes, such as quartz countertops and stainless steel appliances. Whether you're a professional or a student, our studios provide a modern retreat designed with your lifestyle in mind.\n\nMcKinney Village sets the stage for an exceptional living experience, complete with an in-home washer/dryer for ultimate convenience. Our community also features a range of amenities such as a 24-hour fitness center, a welcoming resident lounge with complimentary coffee, and a dedicated bike repair station. Situated in the vibrant Medical District, our location offers easy access to all that McKinney has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in McKinney, TX | McKinney Village",
      "seo_description": "Find luxury studio apartments in McKinney, TX at McKinney Village. Enjoy modern finishes and convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mckinney-village",
      "search_query": "one bedroom apartments McKinney Village",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments at McKinney Village",
      "h2_subtitle": "Discover the charm of one-bedroom apartments in McKinney Village. Enjoy luxury features and amenities designed for an upscale lifestyle.",
      "page_copy": "Welcome to McKinney Village, where our one-bedroom apartments offer an elegant retreat in the heart of the Allen/McKinney area. Our thoughtfully designed layouts include premium features such as quartz countertops, stainless steel appliances, and Nest thermostats, creating a space that feels both luxurious and inviting. Perfect for singles or couples, these apartments provide the comfort and style you desire.\n\nLiving in McKinney Village means access to unparalleled community amenities. From a state-of-the-art 24-hour fitness studio to a resident lounge serving gourmet coffee, and an off-leash bark park for your furry friends, every aspect of our community is tailored to support an active and engaged lifestyle. Situated in McKinney's thriving Medical District, our location offers convenience and connectivity to the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in McKinney Village",
      "seo_description": "Find luxury one-bedroom apartments at McKinney Village. Enjoy upscale living with modern amenities in a prime McKinney, TX location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-collin-county",
      "search_query": "two bedroom apartments Collin County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Collin County",
      "h2_subtitle": "Experience spacious living in Collin County with our two-bedroom apartments. McKinney Village offers modern amenities and elegant design.",
      "page_copy": "Discover the spacious elegance of two-bedroom apartments at McKinney Village, nestled in the vibrant community of Collin County. Ideal for families or those needing extra space, these apartments provide an expansive living area adorned with premium features like quartz countertops, stainless steel appliances, and Nest thermostats. Enjoy the perfect blend of comfort and style, ideal for today’s modern lifestyle.\n\nOur community boasts exceptional amenities that cater to all your needs. Take advantage of our 24-hour fitness studio, perfect for unwinding after a long day, or relax in our resident lounge with complimentary gourmet coffee. For those with pets, our off-leash bark park is a delight, making McKinney Village not only a home but a complete community. With a prime location in McKinney's Medical District, enjoy easy access to everything Collin County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Collin County, TX",
      "seo_description": "Explore two-bedroom apartments in Collin County at McKinney Village. Enjoy spacious layouts and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-near-collin-college-technical-campus",
      "search_query": "apartments near Collin College Technical Campus McKinney",
      "category": "School",
      "h1_title": "Apartments Near Collin College Technical Campus",
      "h2_subtitle": "Find premier living near Collin College Technical Campus at McKinney Village. Experience luxury and convenience steps from education.",
      "page_copy": "McKinney Village offers ideal accommodations for those seeking apartments near Collin College Technical Campus. Located just a short distance from the campus, our community provides an easy and convenient commute, perfect for students and faculty members alike. Enjoy modern living with stylish features like stainless steel appliances and quartz countertops, designed to meet the demands of active academic life.\n\nExperience McKinney Village's resort-inspired amenities that elevate your daily routine. Unwind after classes in our resident lounge with complimentary gourmet coffee, or stay active with our comprehensive 24-hour fitness studio featuring cardio and resistance training equipment. Our vibrant community supports both work and play, ensuring you have a balanced living experience near your educational pursuits in McKinney, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxurious Apartments Near Collin College, McKinney",
      "seo_description": "Discover luxurious apartments near Collin College Technical Campus at McKinney Village. Experience convenience and stylish living in McKinney, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-close-to-mckinney-campus-collin-county",
      "search_query": "apartments close to McKinney Campus in Collin County",
      "category": "School",
      "h1_title": "Apartments Close to McKinney Campus",
      "h2_subtitle": "Live near McKinney Campus in Collin County. McKinney Village offers convenient and stylish living options in a vibrant community.",
      "page_copy": "At McKinney Village, experience the best of both worlds with our apartments that are conveniently close to the McKinney Campus in Collin County. Ideal for students, educators, or professionals connected to the campus, our community offers modern amenities and elegant interiors, ensuring a seamless blend of comfort and convenience. Enjoy features such as quartz countertops, stainless steel appliances, and in-home laundry facilities that cater to a modern lifestyle.\n\nOur location provides more than just proximity; it offers a vibrant community experience. Dive into various activities with on-site amenities like our 24-hour fitness studio and a welcoming resident lounge. Whether you're starting your day with a workout or relaxing with a cup of gourmet coffee, McKinney Village is designed for both productivity and leisure. Embrace a lifestyle that supports your academic or professional journey in the heart of Collin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near McKinney Campus, TX",
      "seo_description": "Explore stylish apartments close to McKinney Campus in Collin County. McKinney Village offers modern living with convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-near-medical-city-mckinney",
      "search_query": "apartments near Medical City McKinney",
      "category": "Hospital",
      "h1_title": "Apartments Near Medical City McKinney",
      "h2_subtitle": "Discover convenient living near Medical City McKinney. McKinney Village offers luxury apartments in a prime location.",
      "page_copy": "Located steps away from Medical City McKinney, McKinney Village provides the perfect blend of luxury and proximity. For healthcare professionals and patients alike, our apartments offer convenience without compromising on comfort. Enjoy features like quartz countertops, stainless steel appliances, and efficient Nest thermostats, all within a stone's throw from the medical hub of McKinney.\n\nEnhance your lifestyle with our top-notch amenities tailored to meet the needs of busy professionals. Unwind in our resident lounge with complimentary gourmet coffee or keep up with your fitness regime at our fully-equipped 24-hour fitness studio. With easy access to Medical City McKinney, residing at McKinney Village ensures you're never far from work while still living in style and tranquility in Collin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Medical City McKinney, TX",
      "seo_description": "Find luxury apartments near Medical City McKinney. McKinney Village offers a prime location with modern comforts and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-near-baylor-scott-white-collin-county",
      "search_query": "apartments close to Baylor Scott & White Medical Center in Collin County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Baylor Scott & White McKinney",
      "h2_subtitle": "Live near Baylor Scott & White Medical Center in Collin County. McKinney Village provides convenient, stylish living in a prime location.",
      "page_copy": "For those seeking proximity to Baylor Scott & White Medical Center in Collin County, McKinney Village offers an ideal living solution. Our community combines ease of access with luxurious amenities, making it perfect for medical professionals and patients alike. With modern features such as quartz countertops, stainless steel appliances, and in-unit laundry facilities, our apartments are designed to provide a comfortable living experience.\n\nAt McKinney Village, everything you need is right at your fingertips. Residents can enjoy a stress-free lifestyle with amenities like a fully-equipped 24-hour fitness studio and a cozy lounge serving complimentary gourmet coffee. Located just a short distance from Baylor Scott & White Medical Center, you'll appreciate the easy commute while enjoying the tranquil atmosphere and high-end comforts of our community in Collin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Apartments Near Baylor Scott & White McKinney",
      "seo_description": "Explore stylish apartments near Baylor Scott & White Medical Center in Collin County. Enjoy luxury and convenience at McKinney Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-near-celebration-park-mckinney",
      "search_query": "apartments near Celebration Park McKinney",
      "category": "Park",
      "h1_title": "Apartments Near Celebration Park McKinney",
      "h2_subtitle": "Find your home near Celebration Park in McKinney. McKinney Village offers modern living with exceptional amenities close to nature.",
      "page_copy": "Nestled in a vibrant area, McKinney Village offers apartments near the beautiful Celebration Park in McKinney. Ideal for those who cherish outdoor activities, our residences provide both proximity to nature and sophisticated living spaces. Each apartment features modern comforts like quartz countertops, stainless steel appliances, and Nest thermostats, all designed to enhance your lifestyle.\n\nBeyond the elegant interiors, our community is equipped with amenities that enrich your daily life. Residents can enjoy a robust fitness routine at our 24-hour studio or socialize over a cup of gourmet coffee in the lounge. With Celebration Park just a short stroll away, you'll have easy access to trails, picnic spots, and playgrounds, creating a perfect balance between modern conveniences and nature's serenity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments Close to Celebration Park McKinney",
      "seo_description": "Discover modern apartments near Celebration Park in McKinney. Enjoy luxury living with convenient access to nature at McKinney Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-heard-museum-tx",
      "search_query": "luxury apartments by Heard Natural Science Museum TX",
      "category": "Park",
      "h1_title": "Luxury Apartments by Heard Museum, TX",
      "h2_subtitle": "Experience luxury living near Heard Natural Science Museum in TX. McKinney Village offers upscale amenities in a prime location.",
      "page_copy": "Discover luxury living at McKinney Village, conveniently located near the Heard Natural Science Museum in Texas. Perfect for nature enthusiasts who appreciate the finer things in life, our luxury apartments boast high-end features such as quartz countertops, stainless steel appliances, and Nest thermostats, ensuring a sophisticated living experience just minutes from the museum.\n\nThe community offers an array of amenities designed to complement your upscale lifestyle. Whether you're enjoying a workout at our state-of-the-art 24-hour fitness studio or relaxing with a gourmet coffee in the resident lounge, McKinney Village provides a perfect blend of elegance and comfort. Located near the Heard Natural Science Museum, residents have easy access to educational exhibits and nature trails, combining leisure and luxury in one unparalleled location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Living Near Heard Museum in TX",
      "seo_description": "Explore luxury living near Heard Natural Science Museum, TX. McKinney Village offers upscale apartments with premier features and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "rentals-near-bonnie-wenk-park-allen",
      "search_query": "rentals close to Bonnie Wenk Park Allen",
      "category": "Park",
      "h1_title": "Rentals Close to Bonnie Wenk Park, Allen",
      "h2_subtitle": "Live near Bonnie Wenk Park in Allen. McKinney Village offers rentals with modern amenities and easy park access.",
      "page_copy": "Situated conveniently close to Bonnie Wenk Park in Allen, McKinney Village offers rentals that cater to those who love the outdoors yet prefer the comforts of modern living. Residents benefit from thoughtfully designed studio, one-, and two-bedroom floor plans featuring quartz countertops, stainless steel appliances, and in-home laundry units, ensuring a hassle-free lifestyle.\n\nOur community enhances everyday living with amenities such as a state-of-the-art fitness studio available 24/7 and a cozy resident lounge with complimentary gourmet coffee. Proximity to Bonnie Wenk Park means you can enjoy scenic walks, vibrant wildlife, and engaging outdoor activities right at your doorstep, making McKinney Village the perfect spot for those who appreciate a blend of convenience and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Rentals Near Bonnie Wenk Park, Allen",
      "seo_description": "Discover modern rentals near Bonnie Wenk Park in Allen. Enjoy luxury amenities and easy access to nature at McKinney Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "apartments-near-towne-lake-park-75069",
      "search_query": "apartments near Towne Lake Park 75069",
      "category": "Park",
      "h1_title": "Apartments Near Towne Lake Park 75069",
      "h2_subtitle": "Discover homes near Towne Lake Park, McKinney 75069. McKinney Village offers stylish living with prime park access.",
      "page_copy": "Located near Towne Lake Park in McKinney's zip code 75069, McKinney Village offers apartments that perfectly blend style and convenience. With easy access to scenic walking trails, picnic areas, and beautiful lake views, our community provides an idyllic setting for those who enjoy outdoor activities without compromising on luxury.\n\nAt McKinney Village, each apartment is designed with premium features such as quartz countertops, stainless steel appliances, and Nest thermostats. The community enhances your living experience with a 24-hour fitness studio, an inviting resident lounge, and even an off-leash bark park for pet owners. With Towne Lake Park just moments away, you'll enjoy the ease of indulging in nature's beauty anytime you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Living Near Towne Lake Park 75069",
      "seo_description": "Explore stylish apartments near Towne Lake Park, McKinney 75069. Enjoy modern features and easy park access at McKinney Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166786",
      "source": "generator",
      "page_item_url": "luxury-living-near-spirit-park-collin-county",
      "search_query": "luxury living near Spirit Park Collin County",
      "category": "Park",
      "h1_title": "Luxury Living Near Spirit Park, Collin County",
      "h2_subtitle": "Experience upscale living near Spirit Park in Collin County. McKinney Village provides a lavish lifestyle and park proximity.",
      "page_copy": "Discover the epitome of luxury living near Spirit Park in Collin County at McKinney Village. Situated in a prime location, our community offers stylish studio, one-, and two-bedroom apartments with top-tier finishes. Enjoy quartz countertops, stainless steel appliances, and Nest thermostats, all designed to complement your refined taste.\n\nBeyond the high-end interiors, McKinney Village boasts a variety of amenities that enhance the luxury experience. Relax in our resident lounge with a gourmet coffee in hand, or stay active at our 24-hour fitness studio. With the beautiful Spirit Park nearby, you have the perfect venue to explore outdoor trails and recreational activities, offering a lavish lifestyle that's richly connected to nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
      "featured_image_media": {
        "alt_text": "A large, sparkling swimming pool with in-water lounge chairs and surrounding lounge chairs, set against a backdrop of brick apartment buildings under a cloudy sky.",
        "public_id": "019d01ae-a7c9-737d-ae4c-c53a1fcf067e",
        "storage_key": "property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Upscale Living Near Spirit Park, Collin County",
      "seo_description": "Enjoy luxury living near Spirit Park in Collin County at McKinney Village. Revel in elegant apartments and proximity to leisure activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5644"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18106366425"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4697278587"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PFCQ6SP8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "2f38d042-22a1-4aaa-b4ee-cac84c1f12f0"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Blue Haven"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://webchat.omni.cafe/conversations/51612c43-4599-4d87-83e8-2583c3cd38b4/app.js?property=51612c43-4599-4d87-83e8-2583c3cd38b4&propertyName=McKinney Village&channelUuid=69c698e8-a9f2-11f0-91ed-42010aa8d42b&buttonbgcolor=ce1443\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40833450414"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/y8px59dqv19"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNRaUpCdzYvelNrdDFreGk2ZWJVZ0E9PSIsInZhbHVlIjoidEZEcnJjenNEUDlCMGcrSjgxTUNUdz09IiwibWFjIjoiNDE5ZDQxMjQyMTEwMmNhZjhmZTg5N2VjYmExZTY4ODg5ZGNlYjNiZDc2ZmEzZTk3ODVhNmQyZTVmNGVmNmJkMCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5644",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "18106366425",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4697278587",
  "custom_google_gtm_id": "GTM-PFCQ6SP8",
  "custom_rollout_phase": "Phase 7.2",
  "custom_rentgrata_token": "2f38d042-22a1-4aaa-b4ee-cac84c1f12f0",
  "custom_vibesites_theme": "Blue Haven",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script src=\"https://webchat.omni.cafe/conversations/51612c43-4599-4d87-83e8-2583c3cd38b4/app.js?property=51612c43-4599-4d87-83e8-2583c3cd38b4&propertyName=McKinney Village&channelUuid=69c698e8-a9f2-11f0-91ed-42010aa8d42b&buttonbgcolor=ce1443\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "40833450414",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/y8px59dqv19",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNRaUpCdzYvelNrdDFreGk2ZWJVZ0E9PSIsInZhbHVlIjoidEZEcnJjenNEUDlCMGcrSjgxTUNUdz09IiwibWFjIjoiNDE5ZDQxMjQyMTEwMmNhZjhmZTg5N2VjYmExZTY4ODg5ZGNlYjNiZDc2ZmEzZTk3ODVhNmQyZTVmNGVmNmJkMCJ9",
  "custom_audioeye_site_id": "4493c414-07de-4b6c-aa58-b3bb74e4e24e",
  "custom_audioeye_site_hash": "3739041be3144c8d1f5a5d0bc8ac4d77"
};

export const generatedAt = '2026-11-03T22:26:52.857Z';
